import { Component, input } from '@angular/core';
import { WorkAggregatedTimerecordBalanceDto } from '@work-frontend-monorepo/work-rest-api';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'sfg-app-absenzen-feriensaldo',
  templateUrl: './absenzen-feriensaldo.component.html',
  styleUrls: ['./absenzen-feriensaldo.component.scss'],
  standalone: true,
  imports: [DecimalPipe, TranslatePipe],
})
export class AbsenzenFeriensaldoComponent {
  balance = input.required<WorkAggregatedTimerecordBalanceDto>();
}
